export default class Delegate {
  constructor () {
    this.id = null
    this.forename = null
    this.surname = null
    this.name = null
    this.memberNo = null
    this.associationName = null
    this.associationNo = null
    this.previousAssociationName = null
    this.gender = null
    this.realPerson = false
    this.spokenCount = null
  }

  static fromJson (json) {
    let delegate = new this()
    if (json.uuid !== null) {
      delegate.id = json.uuid
    }
    if (json.first_name !== null) {
      delegate.forename = json.first_name
    }
    if (json.last_name !== null) {
      delegate.surname = json.last_name
    }
    if (json.full_name !== null) {
      delegate.name = json.full_name
    }
    if (json.association_name !== null) {
      delegate.associationName = json.association_name
    }
    if (json.association_no !== null) {
      delegate.associationNo = json.association_no
    }
    if (json.previous_association_name !== null) {
      delegate.previousAssociationName = json.previous_association_name
    }
    if (json.delegate_member_no !== null) {
      delegate.memberNo = json.delegate_member_no
    }
    if (json.real_person !== null) {
      delegate.realPerson = json.real_person === 1 || json.real_person === '1'
    }
    if (json.gender !== null) {
      delegate.gender = json.gender
    }
    if (json.spoken !== null) {
      delegate.spokenCount = json.spoken
    }
    delegate.name = delegate.realPerson ? delegate.getName() : delegate.associationName
    return delegate
  }

  getName () {
    if (this.name !== null && this.name !== undefined) {
      return this.name
    }
    if (
      this.forename !== null &&
      this.forename !== undefined &&
      this.surname !== null
    ) {
      return `${this.forename} ${this.surname}`
    }
    return ''
  }

  addAmendnment (amendment) {
    this.amendments.push(amendment)
  }

  hasAmendments () {
    return this.amendments.length > 0
  }
}



// WEBPACK FOOTER //
// ./src/models/delegate.js